import { connect } from 'react-redux/dist/react-redux';
import DetailCapacite from '../components/DetailCapacite';
export default connect()(DetailCapacite);
